import { v5 as uuidv5, v7 as uuidv7, validate } from 'uuid'

/** A UUIDv7 minted on the device (ARCHITECTURE 9.3, I5): time-ordered, collision-safe offline. */
export const newId = (): string => uuidv7()

/** Derived ids use the same v5 namespace/name rules as the database (`extensions.uuid_generate_v5`). */
export const derivedId = (namespace: string, name: string): string => uuidv5(name, namespace)

export const isUuid = (s: unknown): s is string => typeof s === 'string' && validate(s)

export const UUID_PATTERN = '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$'

/** Photos (M8): the file is named by its content, so the same bytes are one file whoever sends them; the link by what it is evidence for. Identical to the database's derivation. */
export const attachmentFileId = (orgId: string, sha256Hex: string): string => derivedId(orgId, sha256Hex)
export const attachmentLinkId = (fileId: string, entityType: string, entityId: string, purpose = 'evidence'): string => derivedId(fileId, `${entityType}:${entityId}:${purpose}`)
// M15-V: a PDF of the documents bucket is stored as .pdf (the server's private.file_ext says the same)
const EXT: Record<string, string> = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'application/pdf': 'pdf' }
export const attachmentStorageKey = (orgId: string, siteId: string, sha256Hex: string, mime: string): string => `org/${orgId}/site/${siteId}/${sha256Hex.slice(0, 2)}/${sha256Hex}.${EXT[mime] ?? 'webp'}`
